
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol id=\"cancel-icon_jax_e1ac6002cda8d025f32785151bc3a80f\" ><path d=\"M1 1l12 12M13 1L1 13\" stroke=\"#303030\" stroke-width=\"1.5\" stroke-linecap=\"round\"/></symbol>";
module.exports = sprite.add(image, "cancel-icon_jax_e1ac6002cda8d025f32785151bc3a80f");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cancel-icon.svg
// module id = 303
// module chunks = 1